import { reactive } from "vue";

const waitings = reactive<{
[id: string]: (value: unknown) => void
}>({})

export function imageLoaded(id: string) {
  if(waitings[id]) waitings[id](true)
}

export async function waitLoading(id: string) {
  return new Promise(resolve => {
    waitings[id] = resolve
    setTimeout(resolve, 2000)
  })
}
